import React from 'react';

import classNames from 'classnames';
import styles from './OrderPostitions.module.scss';

type OrderPositionsType = {
  currentAmount: number;
  initialAmount: number;
};

const OrderPositions: React.FC<OrderPositionsType> = ({ currentAmount, initialAmount }) => {
  const containerClass = classNames(styles.Container, initialAmount !== currentAmount && styles.Container_Danger);

  return (
    <div className={containerClass}>
      Поз: {currentAmount} ({initialAmount})
    </div>
  );
};

export default OrderPositions;
